<template>
  <div>
    <div class="w-full h-16 px-6 py-3 bg-white flex justify-end items-center">
      <div class="w-full justify-end items-center gap-[30px] flex">
        <!-- Temporizador -->
        <div
          v-if="isTimerActive"
          class="w-[200px] h-10 pl-4 pr-5 py-2.5 bg-slate-100 rounded-lg shadow border border-blue-700 justify-center items-center gap-2 flex"
        >
          <img
            v-if="elapsedTimeOnlySeconds > 0"
            @click="stopTimer"
            src="/icons/global-timer/stop.svg"
            alt="Stop"
            class="w-5 h-5 cursor-pointer"
          />
          <img
            v-if="isPaused"
            @click="startTimer"
            src="/icons/nav-bar/play.svg"
            alt="Play"
            class="w-5 h-5 cursor-pointer"
          />
          <img
            v-else
            @click="pauseTimer"
            src="/icons/global-timer/pause_grey.svg"
            alt="Pause"
            class="w-5 h-5 cursor-pointer"
          />
          <div
            class="text-blue-700 text-base font-medium font-['Inter'] leading-normal"
          >
            {{ formattedTime }}
          </div>
        </div>
        <button
          v-else
          @click="openStartModal"
          class="w-[200px] pl-4 pr-5 py-2.5 rounded-lg shadow border border-slate-500 justify-center items-center gap-2 flex"
        >
          <img class="w-9 h-9" src="/icons/nav-bar/play.svg" alt="" />
          <div
            class="text-slate-500 text-base font-medium font-['Inter'] leading-normal"
          >
            Time Tracker
          </div>
        </button>

        <!-- Ayuda y notificaciones -->
        <div class="items-center gap-[15px] flex">
          <button class="p-2.5 rounded-lg bg-slate-100 flex items-center">
            <img class="w-5 h-5" src="/icons/nav-bar/question.svg" alt="Help" />
          </button>
          <button
            class="relative p-2.5 rounded-lg bg-slate-100 flex items-center"
            @click="toggleNotifications"
          >
            <img
              class="w-5 h-5"
              src="/icons/nav-bar/notification.svg"
              alt="Notifications"
            />
            <span
              v-if="unreadCount > 0"
              class="absolute top-0 right-0 translate-x-2 -translate-y-2 bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full"
            >
              {{ unreadCount }}
            </span>
          </button>
        </div>

        <ProfileMenu avatar-class="w-10 h-10" menu-class="w-40" />
      </div>
    </div>

    <NavBarModals
      v-model:start="showModalStart"
      v-model:stop="showModalStop"
      v-model:notifications="showNotifications"
    />
  </div>
</template>

<script>
import { useNavBarActions } from "@/composables/useNavBarActions";
import ProfileMenu from "./ProfileMenu.vue";
import NavBarModals from "./NavBarModals.vue";

// Barra superior de escritorio.
export default {
  components: { ProfileMenu, NavBarModals },
  setup() {
    return { ...useNavBarActions() };
  },
};
</script>
